export default {
  data() {
    return { lastWheelTime: 0 };
  },
  methods: {
    scrollMixinEvent(event, currValue, minValue = 0, maxValue = null) {
      let currentValue = Number(currValue);

      let toAdd = 1;
      if (this.lastWheelTime != null) {
        let diff = Date.now() - this.lastWheelTime;
        if (diff < 6) {
          toAdd = 6;
        } else if (diff < 12) {
          toAdd = 4;
        } else if (diff < 18) {
          toAdd = 2;
        }
      }

      this.lastWheelTime = Date.now();

      if (event.deltaY < 0) {
        currentValue = this.toFloat(currentValue + Number(toAdd));
      } else {
        currentValue = this.toFloat(currentValue - Number(toAdd));
      }

      if (currentValue < minValue) currentValue = minValue;

      if (maxValue != null && currentValue > maxValue) currentValue = maxValue;

      return currentValue;
    },
  },
};
